import { useMutation } from '@tanstack/react-query';
import { ActivityParam, NewActivitiesResponse, sendCreateNewActivities } from 'activities/senders';
import { queryClient } from 'common/providers/QueryProvider';
import { FIELDS_ACTIVITIES_QUERY_KEY } from '../useGetActivitiesForFields/constants';
import { trackError } from 'util/error';
import { addErrorToast } from 'messages';
import { getMessage } from 'util/locale';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getActiveUserId } from 'current/selectors';
import { Activity } from 'store/types/types';

export const useCreateActivities = () => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(getActiveUserId);

  return useMutation<NewActivitiesResponse, Error, ActivityParam[]>({
    mutationFn: (activitiesParams) => sendCreateNewActivities({ activitiesParams, userId }),
    onSuccess: ({ activities }, activitiesParams) => {
      activitiesParams.forEach(({ fieldUuid, type, date, season }, index) => {
        queryClient.setQueryData<Activity[]>(
          [FIELDS_ACTIVITIES_QUERY_KEY, type, fieldUuid],
          (prev) => {
            const newActivity = {
              uuid: activities[index],
              type,
              date,
              'field-uuid': fieldUuid,
              season
            };

            if (!prev) {
              return [newActivity];
            }

            return [...prev, newActivity];
          });
      });
    },
    onError: (error) => {
      trackError(new Error('Could not create new groot activities'), { error });
      dispatch(addErrorToast(getMessage('help-text__failure--save-prescriptions')));
      
      throw error;
    }
  });
};
